import React, { useState, useEffect } from "react";
import {
  Box,
  Flex,
  Select,
  Table,
  Thead,
  Tbody,
  Tr,
  HStack,
  Th,
  Td,
  Text,
  Image,
  Badge,
  Button,
  Avatar,
  Stack,
  useToast,
  IconButton,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button as ChakraButton,
} from "@chakra-ui/react";
import { EditIcon, DeleteIcon } from "@chakra-ui/icons";
import axios from "axios";
import Bus_Edit from "./Bus_Edit";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const BusTable = () => {
  const [data, setData] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [busToDelete, setBusToDelete] = useState(null);
  const toast = useToast();

  useEffect(() => {
    fetchBusDetails();
  }, []);

  const RefreshData = () => {
    fetchBusDetails();
  };

  const fetchBusDetails = async () => {
    setLoading(true);
    try {
      const schoolId = sessionStorage.getItem("school_id");
      const response = await axios.get(
        `${BASE_URL}/admin/bus/vehicle/list_all_bus_details.php`,
        {
          params: { school_id: schoolId },
        }
      );
      console.log("list_bus_details", response);

      if (response.data.success) {
        setData(response.data.data);
      } else {
        toast({
          title: "Error",
          description: response.data.message || "Failed to fetch data.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: "Error",
        description: "Failed to fetch bus details.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    if (!busToDelete) return;

    try {
      const userId = sessionStorage.getItem("user_id");
      const schoolId = sessionStorage.getItem("school_id");

      if (!userId || !schoolId) {
        toast({
          title: "Error",
          description: "User ID or School ID is missing.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        return;
      }

      const response = await axios.delete(
        `${BASE_URL}/admin/bus/vehicle/delete_bus_details.php`,
        {
          data: { bus_id: busToDelete, user_id: userId, school_id: schoolId },
        }
      );
      console.log("delete_bus", response);

      if (response.data.success) {
        toast({
          title: "Success",
          description: "Bus deleted successfully.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        fetchBusDetails(); // Refresh data
      } else {
        toast({
          title: "Error",
          description: response.data.message || "Failed to delete bus.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: "Error",
        description: "Failed to delete bus.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsDeleteModalOpen(false);
    }
  };

  const totalPages = Math.ceil(data.length / rowsPerPage);
  const currentData = data.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1); // Reset to first page when rows per page change
  };

  return (
    <Box padding="0">
      <Flex justify="space-between" className="sb" p={3}>
        <Select
          width="120px"
          value={rowsPerPage}
          onChange={handleRowsPerPageChange}
        >
          <option value={5}>5</option>
          <option value={10}>10</option>
          <option value={20}>20</option>
        </Select>
      </Flex>

      {loading ? (
        <Text>Loading...</Text>
      ) : (
        <Box overflowX="auto" maxWidth="100%">
          <Table
            sx={{
              "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
              "th, td": {
                textAlign: "center",
              },
            }}
          >
            <Thead>
              <Tr>
                <Th>Vehicle No</Th>
                <Th>Vehicle Model</Th>
                <Th>Year</Th>
                <Th>Registration No</Th>
                <Th>Driver</Th>
                <Th>Conductor</Th>
                <Th>Departure</Th>
                <Th>Arrival</Th>

                <Th>Status</Th>
                <Th>Actions</Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentData.map((row) => (
                <Tr key={row.id}>
                  <Td>{row.bus_no}</Td>
                  <Td>{row.vehicle_model}</Td>
                  <Td>{row.model_year}</Td>
                  <Td>{row.reg_no}</Td>
                  <Td>
                    <Flex align="center">
                      <Avatar
                        src={row.image_url}
                        alt={row.driver}
                        name={row.driver}
                        size="sm"
                        onError={(e) => {
                          e.target.src =
                            "https://t4.ftcdn.net/jpg/02/29/75/83/360_F_229758328_7x8jwCwjtBMmC6rgFzLFhZoEpLobB6L8.jpg";
                        }}
                      />
                      <Text ml={2}>{row.driver || "N/A"}</Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align="center">
                      <Avatar
                        src={row.image_url}
                        alt={row.conductor}
                        name={row.conductor}
                        size="sm"
                        onError={(e) => {
                          e.target.src =
                            "https://t4.ftcdn.net/jpg/02/29/75/83/360_F_229758328_7x8jwCwjtBMmC6rgFzLFhZoEpLobB6L8.jpg";
                        }}
                      />
                      <Text ml={2}>{row.conductor || "N/A"}</Text>
                    </Flex>
                  </Td>

                  <Td>{row.time_from_school}</Td>

                  <Td>{row.time_to_school}</Td>

                  <Td>
                    <Badge
                      borderRadius="full"
                      fontSize="10px"
                      colorScheme={row.status === 1 ? "green" : "green"}
                    >
                      {row.status === 1 ? "Active" : "Active"}
                    </Badge>
                  </Td>
                  <Td>
                    <Stack direction="row" spacing={2}>
                      <Bus_Edit bus_id={row.id} RefreshData={RefreshData} />
                      <IconButton
                        icon={<DeleteIcon />}
                        colorScheme="red"
                        size="sm"
                        onClick={() => {
                          setBusToDelete(row.id);
                          setIsDeleteModalOpen(true);
                        }}
                        aria-label="Delete"
                      />
                    </Stack>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>
      )}

      <Flex justify="end" align="center" className="sb2" p={3}>
        <Button
          onClick={() => handlePageChange(currentPage - 1)}
          isDisabled={currentPage === 1}
        >
          Prev
        </Button>

        <Stack direction="row" spacing={2} mx={2}>
          {Array.from({ length: totalPages }, (_, i) => (
            <Button
              key={i}
              onClick={() => handlePageChange(i + 1)}
              colorScheme={currentPage === i + 1 ? "teal" : "gray"}
            >
              {i + 1}
            </Button>
          ))}
        </Stack>

        <Button
          onClick={() => handlePageChange(currentPage + 1)}
          isDisabled={currentPage === totalPages}
        >
          Next
        </Button>
      </Flex>

      {/* Modal for Deletion Confirmation */}
      <Modal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Confirm Deletion</ModalHeader>
          <ModalCloseButton />
          <ModalBody>Are you sure you want to delete this bus?</ModalBody>

          <ModalFooter>
            <ChakraButton colorScheme="red" onClick={handleDelete}>
              Delete
            </ChakraButton>
            <ChakraButton
              variant="ghost"
              onClick={() => setIsDeleteModalOpen(false)}
            >
              Cancel
            </ChakraButton>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default BusTable;
